import { useState, useEffect } from 'react'
import { useSidebar } from '@/components/ui/sidebar'
import { useUser } from '@/pages/enterprise/user-provider'
import { cn } from '@/lib/utils'
import MenuHeaderDesktop from './menu-header-desktop'
import MenuHeaderMobile from './menu-header-mobile'

export type IHeaderMenu = Array<{
  name: string
  href: string
  isActive?: boolean
}>
export const headerMenuItems: IHeaderMenu = [
  {
    name: 'Map',
    href: '/',
  },
  {
    name: 'Portfolio',
    href: '/portfolio',
  },
  {
    name: 'Reports',
    href: '/reports',
  },
  {
    name: 'Profile',
    href: '/profile',
  },
  {
    name: 'Enterprise Admin',
    href: '/enterprise',
    isActive: true,
  },
]

export function HeaderUser() {
  const { fullname, role } = useUser()
  const [isScrolled, setIsScrolled] = useState(false)

  const user = {
    name: fullname,
    role: role === 7 ? 'Enterprise Admin' : 'Enterprise Member',
  }
  const { open, toggleSidebar } = useSidebar()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header
      className={cn(
        'fixed top-0 left-[240px] right-0 duration-200 bg-sidebar flex h-16 shrink-0 items-center gap-2 transition-all ease-linear z-10',
        { 'shadow-sm': isScrolled, 'left-[86px]': !open }
      )}
    >
      <div className="flex flex-row justify-between items-center pl-[30px] md:pr-[2.5rem] pr-4 w-full">
        <div
          className={cn('-ml-2 p-2 cursor-pointer', {
            hidden: !open,
          })}
          onClick={() => {
            toggleSidebar()
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
              stroke="#202224"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 3V21M16 15L13 12L16 9"
              stroke="#202224"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div className="w-full flex flex-row justify-end items-center gap-8">
          <MenuHeaderDesktop menu={headerMenuItems} />

          <div className="gap-4 flex flex-row">
            <div className="grid text-left text-sm leading-tight">
              <span className="truncate font-semibold">{user.name}</span>
              <span className="truncate text-xs">{user.role}</span>
            </div>
            <MenuHeaderMobile menu={headerMenuItems} />
          </div>
        </div>
      </div>
    </header>
  )
}
